// import { useEffect, useState } from "react";
// import api from "../api/axiosInstance";
// import {
//   ChevronLeft,
//   ChevronRight,
//   Wifi,
//   Car,
//   Coffee,
//   Utensils,
//   Tv,
//   Wind,
//   ShowerHead, // Changed from Shower to ShowerHead
//   Bed,
//   Users,
// } from "lucide-react";

// const GuestRoom = () => {
//   const [rooms, setRooms] = useState([]);
//   const [currentRoomIndex, setCurrentRoomIndex] = useState(0);
//   const [currentImageIndex, setCurrentImageIndex] = useState(0);
//   const [loading, setLoading] = useState(true);

//   // ✅ Fetch rooms from backend
//   useEffect(() => {
//     const fetchRooms = async () => {
//       try {
//         const res = await api.get("/guest-rooms/get/all");
//         setRooms(res.data);
//       } catch (err) {
//         console.error(err);
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchRooms();
//   }, []);

//   // ✅ Improved amenity icon mapping
//   const getAmenityIcon = (amenity) => {
//     const amenityLower = amenity.toLowerCase().trim();

//     if (amenityLower.includes("wifi") || amenityLower.includes("wi-fi")) {
//       return <Wifi size={20} className="text-emerald-500" />;
//     }
//     if (amenityLower.includes("parking") || amenityLower.includes("car")) {
//       return <Car size={20} className="text-emerald-500" />;
//     }
//     if (amenityLower.includes("coffee") || amenityLower.includes("tea")) {
//       return <Coffee size={20} className="text-emerald-500" />;
//     }
//     if (amenityLower.includes("tv") || amenityLower.includes("television")) {
//       return <Tv size={20} className="text-emerald-500" />;
//     }
//     if (
//       amenityLower.includes("ac") ||
//       amenityLower.includes("air conditioning") ||
//       amenityLower.includes("air conditioner")
//     ) {
//       return <Wind size={20} className="text-emerald-500" />;
//     }
//     if (amenityLower.includes("bathroom") || amenityLower.includes("shower")) {
//       return <ShowerHead size={20} className="text-emerald-500" />; // Fixed: ShowerHead instead of Shower
//     }
//     if (amenityLower.includes("bed")) {
//       return <Bed size={20} className="text-emerald-500" />;
//     }
//     if (
//       amenityLower.includes("restaurant") ||
//       amenityLower.includes("food") ||
//       amenityLower.includes("dining")
//     ) {
//       return <Utensils size={20} className="text-emerald-500" />;
//     }
//     if (
//       amenityLower.includes("people") ||
//       amenityLower.includes("guest") ||
//       amenityLower.includes("capacity")
//     ) {
//       return <Users size={20} className="text-emerald-500" />;
//     }

//     // Default icon for unmatched amenities
//     return (
//       <div className="w-5 h-5 rounded-full bg-emerald-500 flex items-center justify-center">
//         <span className="text-white text-xs">✓</span>
//       </div>
//     );
//   };

//   if (loading) return <div className="p-10 text-center">Loading...</div>;
//   if (rooms.length === 0)
//     return (
//       <div className="p-10 text-center text-gray-500">
//         No guest rooms available
//       </div>
//     );

//   const room = rooms[currentRoomIndex];
//   const images = room.imageUrls || [];
//   const amenities = room.amenities
//     ? room.amenities
//         .split(",")
//         .map((a) => a.trim())
//         .filter((a) => a)
//     : [];

//   const nextImage = () => {
//     setCurrentImageIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1));
//   };

//   const prevImage = () => {
//     setCurrentImageIndex((prev) => (prev === 0 ? images.length - 1 : prev - 1));
//   };

//   return (
//     <div className="min-h-screen bg-gray-50">
//       {/* Header */}
//       <div className="bg-white shadow-sm">
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
//           <h1 className="text-3xl font-bold text-gray-900">
//             Luxury Guest Rooms
//           </h1>
//           <p className="text-gray-600 mt-2">
//             Experience comfort and elegance at RGCC
//           </p>
//         </div>
//       </div>

//       {/* Main Content */}
//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
//         <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
//           {/* Image Gallery */}
//           <div className="space-y-4">
//             {/* Main Image */}
//             <div className="relative rounded-2xl overflow-hidden shadow-lg">
//               <img
//                 src={images[currentImageIndex]}
//                 alt="Guest Room"
//                 className="w-full h-96 object-cover"
//               />

//               {/* Navigation Arrows */}
//               {images.length > 1 && (
//                 <>
//                   <button
//                     onClick={prevImage}
//                     className="absolute left-4 top-1/2 -translate-y-1/2 bg-white/80 hover:bg-white rounded-full p-2 transition-all duration-200"
//                   >
//                     <ChevronLeft size={24} />
//                   </button>
//                   <button
//                     onClick={nextImage}
//                     className="absolute right-4 top-1/2 -translate-y-1/2 bg-white/80 hover:bg-white rounded-full p-2 transition-all duration-200"
//                   >
//                     <ChevronRight size={24} />
//                   </button>
//                 </>
//               )}

//               {/* Image Counter */}
//               <div className="absolute bottom-4 left-1/2 -translate-x-1/2 bg-black/50 text-white px-3 py-1 rounded-full text-sm">
//                 {currentImageIndex + 1} / {images.length}
//               </div>
//             </div>

//             {/* Thumbnails */}
//             {images.length > 1 && (
//               <div className="grid grid-cols-3 gap-2">
//                 {images.map((image, index) => (
//                   <button
//                     key={index}
//                     onClick={() => setCurrentImageIndex(index)}
//                     className={`rounded-lg overflow-hidden border-2 transition-all duration-200 ${
//                       index === currentImageIndex
//                         ? "border-emerald-500"
//                         : "border-transparent"
//                     }`}
//                   >
//                     <img
//                       src={image}
//                       alt={`Guest Room ${index + 1}`}
//                       className="w-full h-24 object-cover hover:scale-105 transition-transform duration-200"
//                     />
//                   </button>
//                 ))}
//               </div>
//             )}
//           </div>

//           {/* Room Details */}
//           <div className="space-y-6">
//             <div className="bg-white rounded-2xl p-6 shadow-lg">
//               <div className="flex justify-between items-start mb-4">
//                 <div>
//                   <h2 className="text-2xl font-bold text-gray-900">
//                     {room.title}
//                   </h2>
//                   <p className="text-gray-600 mt-2">{room.description}</p>
//                 </div>

//                 {/* {room.pricePerNight && (
//                   <div className="text-right">
//                     <p className="text-3xl font-bold text-emerald-600">
//                       ৳{room.pricePerNight}
//                     </p>
//                     <p className="text-gray-500 text-sm">per night</p>
//                   </div>
//                 )} */}
//               </div>

//               {/* Amenities */}
//               {amenities.length > 0 && (
//                 <div className="mb-6">
//                   <h3 className="text-lg font-semibold text-gray-900 mb-4">
//                     Amenities
//                   </h3>
//                   <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
//                     {amenities.map((amenity, index) => (
//                       <div
//                         key={index}
//                         className="flex items-center gap-3 p-2 bg-gray-50 rounded-lg"
//                       >
//                         {getAmenityIcon(amenity)}
//                         <span className="text-gray-700 font-medium">
//                           {amenity}
//                         </span>
//                       </div>
//                     ))}
//                   </div>
//                 </div>
//               )}

//               {/* Standard Features */}
//               <div>
//                 <h3 className="text-lg font-semibold text-gray-900 mb-4">
//                   Room Features
//                 </h3>
//                 <ul className="space-y-2 text-gray-600">
//                   <li className="flex items-center gap-2">
//                     <div className="w-2 h-2 bg-emerald-500 rounded-full"></div>
//                     King-size bed with premium linens
//                   </li>
//                   <li className="flex items-center gap-2">
//                     <div className="w-2 h-2 bg-emerald-500 rounded-full"></div>
//                     En-suite bathroom with luxury toiletries
//                   </li>
//                   <li className="flex items-center gap-2">
//                     <div className="w-2 h-2 bg-emerald-500 rounded-full"></div>
//                     Air conditioning and heating
//                   </li>
//                   <li className="flex items-center gap-2">
//                     <div className="w-2 h-2 bg-emerald-500 rounded-full"></div>
//                     Flat-screen TV with satellite channels
//                   </li>
//                   <li className="flex items-center gap-2">
//                     <div className="w-2 h-2 bg-emerald-500 rounded-full"></div>
//                     Work desk and seating area
//                   </li>
//                   <li className="flex items-center gap-2">
//                     <div className="w-2 h-2 bg-emerald-500 rounded-full"></div>
//                     Daily housekeeping service
//                   </li>
//                 </ul>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Contact Section */}
//         <div className="mt-12 bg-gradient-to-r from-emerald-500 to-green-600 rounded-2xl p-8 text-white text-center">
//           <h3 className="text-2xl font-bold mb-4">Need Assistance?</h3>
//           <p className="text-lg mb-6">
//             Our team is here to help you with your booking
//           </p>
//           <div className="flex flex-col sm:flex-row gap-4 justify-center">
//             <button className="bg-white text-emerald-600 font-semibold py-3 px-8 rounded-lg hover:bg-gray-100 transition-colors duration-200">
//               Call: +88 01766693142
//             </button>
//             <button className="border-2 border-white text-white font-semibold py-3 px-8 rounded-lg hover:bg-white hover:text-emerald-600 transition-all duration-200">
//               Email: rgcc66div@gmail.com
//             </button>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default GuestRoom;

import { useEffect, useState } from "react";
import api from "../api/axiosInstance";
import {
  ChevronLeft,
  ChevronRight,
  Wifi,
  Car,
  Coffee,
  Utensils,
  Tv,
  Wind,
  ShowerHead,
  Bed,
  Users,
  Sparkles,
  Star,
  CheckCircle,
  Clock,
  Heart,
  Maximize2,
  Phone,
  Mail,
  Shield,
  Award,
  BedDouble,
  Sofa,
  Briefcase,
  Map,
  Sparkle,
} from "lucide-react";

const GuestRoom = () => {
  const [rooms, setRooms] = useState([]);
  const [currentRoomIndex, setCurrentRoomIndex] = useState(0);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [loading, setLoading] = useState(true);
  const [liked, setLiked] = useState(false);

  // ✅ Fetch rooms from backend
  useEffect(() => {
    const fetchRooms = async () => {
      try {
        const res = await api.get("/guest-rooms/get/all");
        setRooms(res.data);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    fetchRooms();
  }, []);

  // ✅ Improved amenity icon mapping
  const getAmenityIcon = (amenity) => {
    const amenityLower = amenity.toLowerCase().trim();

    if (amenityLower.includes("wifi") || amenityLower.includes("wi-fi")) {
      return <Wifi size={20} className="text-emerald-500" />;
    }
    if (amenityLower.includes("parking") || amenityLower.includes("car")) {
      return <Car size={20} className="text-emerald-500" />;
    }
    if (amenityLower.includes("coffee") || amenityLower.includes("tea")) {
      return <Coffee size={20} className="text-emerald-500" />;
    }
    if (amenityLower.includes("tv") || amenityLower.includes("television")) {
      return <Tv size={20} className="text-emerald-500" />;
    }
    if (
      amenityLower.includes("ac") ||
      amenityLower.includes("air conditioning") ||
      amenityLower.includes("air conditioner")
    ) {
      return <Wind size={20} className="text-emerald-500" />;
    }
    if (amenityLower.includes("bathroom") || amenityLower.includes("shower")) {
      return <ShowerHead size={20} className="text-emerald-500" />;
    }
    if (amenityLower.includes("bed")) {
      return <Bed size={20} className="text-emerald-500" />;
    }
    if (
      amenityLower.includes("restaurant") ||
      amenityLower.includes("food") ||
      amenityLower.includes("dining")
    ) {
      return <Utensils size={20} className="text-emerald-500" />;
    }
    if (
      amenityLower.includes("people") ||
      amenityLower.includes("guest") ||
      amenityLower.includes("capacity")
    ) {
      return <Users size={20} className="text-emerald-500" />;
    }

    return (
      <div className="w-5 h-5 rounded-full bg-gradient-to-r from-emerald-500 to-lime-500 flex items-center justify-center">
        <CheckCircle className="w-3 h-3 text-white" />
      </div>
    );
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-emerald-50 via-white to-lime-50 flex items-center justify-center">
        <div className="text-center">
          <div className="inline-flex items-center gap-3">
            <div className="w-6 h-6 border-2 border-emerald-500 border-t-transparent rounded-full animate-spin"></div>
            <span className="text-gray-600">Loading luxury rooms...</span>
          </div>
        </div>
      </div>
    );
  }

  if (rooms.length === 0) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-emerald-50 via-white to-lime-50 flex items-center justify-center">
        <div className="text-center">
          <BedDouble className="w-16 h-16 text-gray-300 mx-auto mb-4" />
          <h3 className="text-xl font-semibold text-gray-700 mb-2">
            No guest rooms available
          </h3>
          <p className="text-gray-500">Please check back later</p>
        </div>
      </div>
    );
  }

  const room = rooms[currentRoomIndex];
  const images = room.imageUrls || [];
  const amenities = room.amenities
    ? room.amenities
        .split(",")
        .map((a) => a.trim())
        .filter((a) => a)
    : [];

  const nextImage = () => {
    setCurrentImageIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1));
  };

  const prevImage = () => {
    setCurrentImageIndex((prev) => (prev === 0 ? images.length - 1 : prev - 1));
  };

  const nextRoom = () => {
    setCurrentRoomIndex((prev) => (prev === rooms.length - 1 ? 0 : prev + 1));
    setCurrentImageIndex(0);
  };

  const prevRoom = () => {
    setCurrentRoomIndex((prev) => (prev === 0 ? rooms.length - 1 : prev - 1));
    setCurrentImageIndex(0);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-emerald-50 via-white to-lime-50">
      {/* Hero Header */}
      <div className="relative bg-gradient-to-r from-emerald-900 via-emerald-800 to-lime-800 text-white py-16 md:py-20 overflow-hidden">
        <div className="absolute inset-0">
          <div className="absolute -top-24 -right-24 w-96 h-96 bg-emerald-600/20 rounded-full blur-3xl"></div>
          <div className="absolute -bottom-24 -left-24 w-96 h-96 bg-lime-600/20 rounded-full blur-3xl"></div>
        </div>

        <div className="relative max-w-7xl mx-auto px-4 md:px-8">
          <div className="flex flex-col md:flex-row md:items-center justify-between gap-8">
            <div>
              <div className="inline-flex items-center gap-2 mb-4">
                <Sparkle className="w-5 h-5 text-emerald-300" />
                <span className="text-sm font-semibold tracking-widest text-emerald-200 uppercase">
                  Luxury Accommodation
                </span>
                <Sparkle className="w-5 h-5 text-emerald-300" />
              </div>

              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6">
                Premium{" "}
                <span className="relative inline-block">
                  <span className="relative z-10">Guest Suites</span>
                  {/* <span className="absolute bottom-2 left-0 w-full h-3 bg-gradient-to-r from-emerald-400 to-lime-400 -rotate-1"></span> */}
                </span>
              </h1>

              <p className="text-xl text-emerald-100 max-w-2xl">
                Experience unparalleled comfort and elegance in our meticulously
                designed guest rooms at RGCC
              </p>
            </div>

            <div className="flex items-center gap-4">
              <div className="text-right">
                <div className="text-2xl font-bold">RGCC Exclusive</div>
                <div className="text-emerald-200">Member & Guest Access</div>
              </div>
              <div className="w-16 h-16 rounded-full bg-gradient-to-br from-emerald-300/20 to-lime-300/20 backdrop-blur-sm border-2 border-emerald-300/30 flex items-center justify-center">
                <BedDouble className="w-8 h-8 text-white" />
              </div>
            </div>
          </div>

          {/* Room Navigation */}
          {rooms.length > 1 && (
            <div className="mt-12 flex items-center justify-between">
              <button
                onClick={prevRoom}
                className="flex items-center gap-2 px-6 py-3 rounded-xl bg-white/10 hover:bg-white/20 transition-all duration-300 group"
              >
                <ChevronLeft className="w-5 h-5 group-hover:-translate-x-1 transition-transform" />
                <span>Previous Room</span>
              </button>

              <div className="text-center">
                <div className="text-emerald-200">Room</div>
                <div className="text-2xl font-bold">
                  {currentRoomIndex + 1}{" "}
                  <span className="text-emerald-300">/</span> {rooms.length}
                </div>
              </div>

              <button
                onClick={nextRoom}
                className="flex items-center gap-2 px-6 py-3 rounded-xl bg-white/10 hover:bg-white/20 transition-all duration-300 group"
              >
                <span>Next Room</span>
                <ChevronRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
              </button>
            </div>
          )}
        </div>
      </div>

      {/* Main Content */}
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-8 md:py-12">
        <div className="grid lg:grid-cols-2 gap-8 lg:gap-12">
          {/* Image Gallery */}
          <div className="space-y-6">
            {/* Main Image */}
            <div className="relative rounded-2xl overflow-hidden shadow-2xl group">
              <img
                src={images[currentImageIndex]}
                alt={room.title}
                className="w-full h-80 md:h-96 object-cover transform transition-transform duration-700 group-hover:scale-105"
              />

              {/* Navigation Arrows */}
              {images.length > 1 && (
                <>
                  <button
                    onClick={prevImage}
                    className="absolute left-4 top-1/2 -translate-y-1/2 w-12 h-12 rounded-full bg-white/90 backdrop-blur-sm flex items-center justify-center text-gray-800 hover:bg-white hover:scale-110 transition-all duration-300 shadow-lg"
                  >
                    <ChevronLeft className="w-6 h-6" />
                  </button>
                  <button
                    onClick={nextImage}
                    className="absolute right-4 top-1/2 -translate-y-1/2 w-12 h-12 rounded-full bg-white/90 backdrop-blur-sm flex items-center justify-center text-gray-800 hover:bg-white hover:scale-110 transition-all duration-300 shadow-lg"
                  >
                    <ChevronRight className="w-6 h-6" />
                  </button>
                </>
              )}

              {/* Image Counter */}
              <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 px-4 py-2 bg-black/50 backdrop-blur-sm rounded-full text-white text-sm">
                {currentImageIndex + 1} / {images.length}
              </div>

              {/* Action Buttons */}
              <div className="absolute top-4 right-4 flex gap-2">
                <button
                  onClick={() => setLiked(!liked)}
                  className="w-10 h-10 rounded-full bg-white/90 backdrop-blur-sm flex items-center justify-center hover:scale-110 transition-all duration-300 shadow-lg"
                >
                  <Heart
                    className={`w-5 h-5 ${
                      liked ? "text-red-500 fill-red-500" : "text-gray-600"
                    }`}
                  />
                </button>
                <button className="w-10 h-10 rounded-full bg-white/90 backdrop-blur-sm flex items-center justify-center hover:scale-110 transition-all duration-300 shadow-lg">
                  <Maximize2 className="w-5 h-5 text-gray-600" />
                </button>
              </div>
            </div>

            {/* Thumbnails */}
            {images.length > 1 && (
              <div className="grid grid-cols-3 gap-3">
                {images.map((image, index) => (
                  <button
                    key={index}
                    onClick={() => setCurrentImageIndex(index)}
                    className={`relative rounded-xl overflow-hidden border-2 transition-all duration-300 group ${
                      index === currentImageIndex
                        ? "border-emerald-500 shadow-lg"
                        : "border-transparent hover:border-emerald-300"
                    }`}
                  >
                    <img
                      src={image}
                      alt={`Room view ${index + 1}`}
                      className="w-full h-24 object-cover group-hover:scale-110 transition-transform duration-300"
                    />
                    {index === currentImageIndex && (
                      <div className="absolute inset-0 bg-gradient-to-t from-emerald-500/20 to-transparent"></div>
                    )}
                  </button>
                ))}
              </div>
            )}

            {/* Room Type Badges */}
            <div className="flex flex-wrap gap-3">
              <div className="px-4 py-2 rounded-full bg-gradient-to-r from-emerald-50 to-lime-50 border border-emerald-100">
                <span className="text-sm font-semibold text-emerald-700">
                  ⭐ Premium Suite
                </span>
              </div>
              <div className="px-4 py-2 rounded-full bg-gradient-to-r from-blue-50 to-cyan-50 border border-blue-100">
                <span className="text-sm font-semibold text-blue-700">
                  🏨 Golf View
                </span>
              </div>
              <div className="px-4 py-2 rounded-full bg-gradient-to-r from-amber-50 to-orange-50 border border-amber-100">
                <span className="text-sm font-semibold text-amber-700">
                  🔒 24/7 Security
                </span>
              </div>
            </div>
          </div>

          {/* Room Details */}
          <div className="space-y-6">
            {/* Room Info Card */}
            <div className="bg-white/90 backdrop-blur-sm rounded-2xl p-6 md:p-8 shadow-xl border border-emerald-100">
              <div className="flex items-start justify-between mb-6">
                <div>
                  <h2 className="text-3xl font-bold text-gray-900 mb-2">
                    {room.title}
                  </h2>
                  <p className="text-lg text-gray-600 leading-relaxed">
                    {room.description}
                  </p>
                </div>

                {/* Price Tag */}
                {room.pricePerNight && (
                  <div className="text-right">
                    <div className="text-4xl font-bold bg-gradient-to-r from-emerald-600 to-lime-600 bg-clip-text text-transparent">
                      ৳{room.pricePerNight}
                    </div>
                    <div className="text-gray-500 text-sm">per night</div>
                  </div>
                )}
              </div>

              {/* Stats Grid */}
              <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8">
                <div className="text-center p-3 rounded-xl bg-gradient-to-br from-emerald-50 to-lime-50">
                  <Bed className="w-6 h-6 text-emerald-600 mx-auto mb-2" />
                  <div className="text-sm font-semibold text-gray-700">
                    King Bed
                  </div>
                </div>
                <div className="text-center p-3 rounded-xl bg-gradient-to-br from-blue-50 to-cyan-50">
                  <Users className="w-6 h-6 text-blue-600 mx-auto mb-2" />
                  <div className="text-sm font-semibold text-gray-700">
                    2-3 Guests
                  </div>
                </div>
                <div className="text-center p-3 rounded-xl bg-gradient-to-br from-amber-50 to-orange-50">
                  <Clock className="w-6 h-6 text-amber-600 mx-auto mb-2" />
                  <div className="text-sm font-semibold text-gray-700">
                    24h Check-in
                  </div>
                </div>
                <div className="text-center p-3 rounded-xl bg-gradient-to-br from-purple-50 to-pink-50">
                  <Shield className="w-6 h-6 text-purple-600 mx-auto mb-2" />
                  <div className="text-sm font-semibold text-gray-700">
                    Secure
                  </div>
                </div>
              </div>

              {/* Amenities Section */}
              {amenities.length > 0 && (
                <div className="mb-8">
                  <h3 className="text-xl font-bold text-gray-900 mb-4 flex items-center gap-2">
                    <Sparkles className="w-5 h-5 text-emerald-500" />
                    Premium Amenities
                  </h3>
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                    {amenities.map((amenity, index) => (
                      <div
                        key={index}
                        className="flex items-center gap-3 p-3 bg-gradient-to-r from-gray-50 to-white rounded-xl border border-gray-100 hover:border-emerald-200 transition-all duration-300 group hover:scale-[1.02]"
                      >
                        <div className="w-10 h-10 rounded-lg bg-gradient-to-br from-emerald-50 to-lime-50 flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                          {getAmenityIcon(amenity)}
                        </div>
                        <span className="font-medium text-gray-700">
                          {amenity}
                        </span>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {/* Standard Features */}
              <div className="mb-8">
                <h3 className="text-xl font-bold text-gray-900 mb-4 flex items-center gap-2">
                  <Star className="w-5 h-5 text-amber-500" />
                  Room Features
                </h3>
                <ul className="space-y-3">
                  <li className="flex items-center gap-3 text-gray-600">
                    <CheckCircle className="w-5 h-5 text-emerald-500 flex-shrink-0" />
                    <span>
                      King-size bed with premium Egyptian cotton linens
                    </span>
                  </li>
                  <li className="flex items-center gap-3 text-gray-600">
                    <CheckCircle className="w-5 h-5 text-emerald-500 flex-shrink-0" />
                    <span>En-suite marble bathroom with luxury toiletries</span>
                  </li>
                  <li className="flex items-center gap-3 text-gray-600">
                    <CheckCircle className="w-5 h-5 text-emerald-500 flex-shrink-0" />
                    <span>
                      Smart 4K TV with satellite channels and streaming
                    </span>
                  </li>
                  <li className="flex items-center gap-3 text-gray-600">
                    <CheckCircle className="w-5 h-5 text-emerald-500 flex-shrink-0" />
                    <span>Ergonomic work desk with high-speed internet</span>
                  </li>
                  <li className="flex items-center gap-3 text-gray-600">
                    <CheckCircle className="w-5 h-5 text-emerald-500 flex-shrink-0" />
                    <span>Daily housekeeping and turndown service</span>
                  </li>
                </ul>
              </div>

              {/* Action Buttons */}
              <div className="flex flex-col sm:flex-row gap-4">
                <button className="flex-1 py-3 px-6 rounded-xl bg-gradient-to-r from-emerald-500 to-lime-500 text-white font-bold hover:from-emerald-600 hover:to-lime-600 transition-all duration-300 transform hover:-translate-y-0.5 shadow-lg hover:shadow-xl">
                  Book This Room
                </button>
                <button className="flex-1 py-3 px-6 rounded-xl border-2 border-emerald-500 text-emerald-600 font-bold hover:bg-emerald-50 transition-all duration-300">
                  Check Availability
                </button>
              </div>
            </div>

            {/* Additional Services */}
            <div className="bg-gradient-to-r from-emerald-50 to-lime-50 rounded-2xl p-6 border border-emerald-100">
              <h3 className="text-xl font-bold text-gray-900 mb-4">
                Additional Services
              </h3>
              <div className="grid grid-cols-2 gap-4">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-lg bg-white flex items-center justify-center">
                    <Briefcase className="w-5 h-5 text-emerald-600" />
                  </div>
                  <span className="text-sm font-medium text-gray-700">
                    Business Center
                  </span>
                </div>
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-lg bg-white flex items-center justify-center">
                    <Coffee className="w-5 h-5 text-emerald-600" />
                  </div>
                  <span className="text-sm font-medium text-gray-700">
                    Coffee Station
                  </span>
                </div>
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-lg bg-white flex items-center justify-center">
                    <Sofa className="w-5 h-5 text-emerald-600" />
                  </div>
                  <span className="text-sm font-medium text-gray-700">
                    Lounge Access
                  </span>
                </div>
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-lg bg-white flex items-center justify-center">
                    <Map className="w-5 h-5 text-emerald-600" />
                  </div>
                  <span className="text-sm font-medium text-gray-700">
                    Tour Guide
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Contact CTA */}
        <div className="mt-12 bg-gradient-to-r from-emerald-500 to-lime-500 rounded-2xl p-8 md:p-12 text-white text-center shadow-2xl">
          <div className="max-w-3xl mx-auto">
            <div className="inline-flex items-center justify-center gap-3 mb-4">
              <Award className="w-8 h-8" />
              <Award className="w-8 h-8" />
              <Award className="w-8 h-8" />
            </div>

            <h3 className="text-2xl md:text-3xl font-bold mb-6">
              Premium Guest Experience Awaits
            </h3>

            <p className="text-emerald-100 text-lg mb-8 max-w-2xl mx-auto">
              Book your stay at RGCC and enjoy world-class hospitality combined
              with championship golf
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a
                href="tel:+8801766693142"
                className="inline-flex items-center justify-center gap-3 px-8 py-3 rounded-xl font-bold bg-white text-emerald-600 hover:bg-emerald-50 hover:scale-105 transition-all duration-300 shadow-lg"
              >
                <Phone className="w-5 h-5" />
                Call Now: +88 01766693142
              </a>

              <a
                href="mailto:rgcc66div@gmail.com"
                className="inline-flex items-center justify-center gap-3 px-8 py-3 rounded-xl font-bold bg-emerald-700 text-white hover:bg-emerald-800 hover:scale-105 transition-all duration-300 shadow-lg border border-emerald-600"
              >
                <Mail className="w-5 h-5" />
                Email: rgcc66div@gmail.com
              </a>
            </div>

            <p className="mt-6 text-sm text-emerald-200">
              📞 Available 24/7 for bookings and inquiries
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GuestRoom;
